import React from 'react';

const DownCarats = (props) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.49 23.78">
            <path fill={props.fill} d="M7.18,13.43.76.61H3l4.65,9.58h.1L13,.61h2.22L8.07,13.43Z"
                  transform="translate(-0.76 -0.61)"/>
            <path fill={props.fill} d="M7.18,24.39.76,11.57H3l4.65,9.58h.1L13,11.57h2.22L8.07,24.39Z"
                  transform="translate(-0.76 -0.61)"/>
        </svg>
    )
};

export default DownCarats



